import * as Sentry from '@sentry/react';

// Only initialise Sentry when a DSN is explicitly configured. A previous
// hard-coded fallback DSN meant every environment shipped events to a fixed
// project even when Sentry was never set up for it — on Skypicks/Delta those
// events were rejected with 403 across dozens of round trips, which slowed the
// login flow. No DSN => no Sentry network traffic at all.
const dsn = import.meta.env.VITE_SENTRY_DSN;
const environment = import.meta.env.VITE_SENTRY_ENV || 'development';
const isProduction = environment === 'production';

if (dsn && import.meta.env.MODE !== 'test') {
  Sentry.init({
    dsn,
    environment,

    // Performance Monitoring
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration({
        maskAllText: false,
        blockAllMedia: false,
      }),
    ],

    // Sample performance traces conservatively. The old non-production default
    // of 1.0 captured 100% of transactions, flooding ingest during login /
    // load-testing.
    tracesSampleRate: isProduction ? 0.1 : 0.2,

    // Session Replay is a continuous uploader. Don't record normal sessions —
    // buffer in memory and only upload a replay when a session actually errors.
    replaysSessionSampleRate: 0,
    replaysOnErrorSampleRate: 1.0,

    // Enable logs
    enableLogs: true,
  });
}
